import { GamesAudioActions, GamesAudioBasePayload } from './props';

export function handleChangeAudio(): GamesAudioBasePayload {
  return {
    type: GamesAudioActions.HandleSoundChange,
  };
}

export function handleMuteSounds(): GamesAudioBasePayload {
  return {
    type: GamesAudioActions.HandleMuteSounds,
  };
}
